// extracted by mini-css-extract-plugin
export var header = "section-row-module--header--cmjuD";
export var headerBox = "section-row-module--header-box--lpQS6";
export var layout2 = "section-row-module--layout2--rEGEg";
export var layout3 = "section-row-module--layout3--e1Qw+";
export var narrowBox = "section-row-module--narrow-box--FTM8q";
export var reverse = "section-row-module--reverse--21Cvh";
export var row = "section-row-module--row--37UG+";
export var wideBox = "section-row-module--wide-box--XCWsv";